import React from 'react'

type Props = {
	width?: number
	height?: number
}

const CalendarPlusIcon = ({ width = 20, height = 20 }: Props) => {
	return (
		<svg width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden>
			<path
				d='M15.835 14.8594H19.084V16.5293H15.835V18.6123H14.165V16.5293H12.082V14.8594H14.165V11.6104H15.835V14.8594ZM5.83398 2.64062H14.4453V1.39062H16.1113V2.86426C16.6095 3.15221 16.9451 3.68993 16.9453 4.30664V10.1406H15.2783V7.22363H3.61133V15.9736H9.29004V17.6406H3.61133C2.69105 17.6404 1.94531 16.894 1.94531 15.9736V4.30664C1.94566 3.38661 2.69127 2.64086 3.61133 2.64062H4.16699V1.39062H5.83398V2.64062ZM3.61133 5.55762H15.2783V4.30664H3.61133V5.55762Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default CalendarPlusIcon
